// 此文件不能引入Config，会导致循环引用

import React from "react";
import { parse } from "qs";
import Moment from "moment";
import lodash from "lodash";
import ReactDom from "react-dom";
import { GetXhr } from "./baseRequest";
import downFileAction from "./downFile";
import { message as antdMessage } from "antd";
import {
  isObject,
  isFunction,
  cloneDeep as lodashCloneDeep,
  cloneDeepWith,
  isArray,
  pick,
  map,
  mergeWith,
  get as lodashGet,
  isString,
  isEqual,
  set as lodashSet,
} from "lodash";
import config from "../config";
export * from "./filterProps";
// 从url取值 name可以参数的key，或者多个key的数组

export const removeTrimStr = (str) => {
  if (!isString(str)) return str;
  return str.replace(/\s+/g, "");
};

export const getQueryString = function (name) {
  let after = window.location.hash.split("?")[1] || "";
  if (!after || !name) {
    return null;
  }

  if (isArray(name)) {
    // 去空格
    let obj = parse(after.trim());
    // 每一项都解码
    map(obj, (v) => {
      return decodeURIComponent(v);
    });
    return pick(obj, name);
  }

  let reg = new RegExp("(^|&)" + name.trim() + "=([^&]*)(&|$)");
  let r = after.trim().match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  } else {
    return null;
  }
};

export const queryToObj = function () {
  const url = window.location.href;
  let result = {};
  if (url.includes("?")) {
    const urlSplit = url.split("?");
    const len = urlSplit.length - 1;
    let queryParam = urlSplit[len] || "";
    queryParam
      .split("&")
      .filter((str) => str !== "")
      .forEach((str) => {
        const [key, value] = str.split("=");
        result[key] = value;
      });
    return result;
  }
  return result;
};

export const queryParam = function (obj, delKey) {
  let result = [];
  Object.entries(obj).forEach((entries) => {
    const [key, value] = entries;
    if (key !== delKey) {
      result.push(`${key}=${value}`);
    }
  });
  return result.join("&");
};

/**
 * 把url尾巴的乱码去掉
 *
 * @param {*} delKey
 * @returns
 */
export const cutOffUrl = function (delKey) {
  const baseUrl = window.location.href;
  const queryObj = queryToObj();
  const queryStr = queryParam(queryObj, delKey);
  const url = get(baseUrl.split("?"), "[0]", baseUrl);
  const result = `${url}${queryStr === "" ? "" : "?" + queryStr}`;
  return result;
};

//多时区
/*
 * dateString  只支持  2019-05-28 15:11:19 时间格式 或者  1559027246000  时间戳格式
 * */
export const timeZone = function (
  dateString,
  format = "YYYY-MM-DD HH:mm:ss",
  isZone = false
) {
  let timeObj = {
    timeStamp: "", //时间戳
    utcTime: "", //utc时间
    utcTimeStamp: "", // utc时间戳
    timeZone: "", //当前时区
    currentZoneTime: "", //当前时区的时间
    time: "", //时间戳直接转为时间
  };
  if (!dateString) return timeObj;

  if (dateString.indexOf("-") > -1 && dateString.length == 10) {
    dateString += " 00";
  }

  //如果不开启时区效果， 则取消时区转换功能
  if (!isZone) {
    timeObj.utcTime = dateString;
    timeObj.currentZoneTime = Moment(dateString).format(format);
    return timeObj;
  }

  if (String(dateString).length == 10) dateString = dateString * 1000;
  //转为时间戳
  timeObj.timeStamp = Date.parse(dateString);
  timeObj.utcTime = Moment.utc(timeObj.timeStamp).format(format);
  timeObj.timeZone = new Date().getTimezoneOffset() / 60; //获取时区
  //当前时区时间等于 UTC时间加上时区偏差
  timeObj.currentZoneTime = Moment(dateString)
    .subtract(timeObj.timeZone, "hour")
    .format(format);
  timeObj.time = Moment(dateString).format(format);
  return timeObj;
};

/*
 *  千分位组件，传入金额，返回千分位数字
 * number {number} 需要格式化的数字 默认0
 * precision {number} 需要保留的小数位，默认0
 * prefix {string} 是否需要加金额前缀，默认false
 * */
export const numberFormat = function ({
  number = 0,
  precision = 0,
  prefix = false,
}) {
  let isPlus = true;
  if (String(number).indexOf("-") > -1) {
    isPlus = false;
    number = Number(String(number).replace(/-/g, ""));
  }
  let displayPrefix = prefix ? prefix : "";
  number = String(number).replace(/(^\s*)|(\s*$)/g, "");
  if (isNaN(number) || !number) {
    return displayPrefix + parseFloat(0).toFixed(precision);
  } else {
    number = parseFloat(number).toFixed(precision);
  }
  number = number + "";
  if (number) {
    let nums = number.split(".");
    let num = nums[0].slice(nums[0].length % 3);
    let numBegin = nums[0].slice(0, nums[0].length % 3);
    number =
      numBegin +
      (numBegin && num ? "," : "") +
      (num ? num.match(/\d{3}/g).join(",") : "") +
      (nums[1] ? "." + nums[1] : "");
  }
  if (!isPlus) {
    number = "-" + number;
  }
  return displayPrefix + number;
};

/**
 * lodash的 get函数超集，当取得值为null、 null、undefined,''将返回默认值
 * path支持数组，会依次选取优先级高的放前面
 * @static
 * @param {object} obj 源数据
 * @param {string|array} path 参数路径
 * @param {*} defaultValue 默认值
 * @returns
 *
 */
export const get = function (obj, path, defaultValue) {
  let value = null;
  const rules = [null, "null", "", undefined];
  const pathList = toArray(path);
  for (let p of pathList) {
    value = lodashGet(obj, p + "", null);
    if (!rules.includes(value)) {
      return value;
    }
  }
  return defaultValue;
};

export const set = function (obj, path, value) {
  if (isEmpty(path)) {
    merge(obj, value);
  } else {
    lodashSet(...arguments);
  }
};

/**
 * 批量获得多个对象的同一个数据路径值
 *
 * @param {string} path 数据路径
 * @param {Array<Object>} objList 对象列表
 * @param {any} defaultValue 默认值
 * @param {string} type 类型
 * @returns
 */
export const batchGet = function (objList, path, defaultValue, type = "array") {
  let result = toArray(objList).map((obj) => get(obj, path, defaultValue));
  if (type === "array") {
    return result;
  } else {
    return result.find((item) => item);
  }
};

/**
 * 在一个对象里面获得多个值
 *
 * @param {*} obj
 * @param {Array} pathList
 * @param {*} defaultValue
 * @returns Array
 */
export const getBatch = function (obj, pathList, defaultValue) {
  let result = [];
  for (let path of toArray(pathList)) {
    const value = get(obj, path, defaultValue);
    result.push(value);
  }
  return result;
};

/**
 * lodash 的 mergeRight 改造，将会选择为null，undefined的值
 *
 * @returns
 */
export const merge = function () {
  return mergeWith(...arguments, (obj, source) => {
    if ([obj, source].some((item) => [null, undefined].includes(item))) {
      return obj || source;
    } else if ([obj, source].every((item) => item instanceof Array)) {
      const objLen = get(obj, "length", 0);
      const sourceLen = get(source, "length", 0);
      if (objLen !== sourceLen) {
        return source;
      }
    }
  });
};

export const message = {
  ...antdMessage,
};

/**
 * 生成序列数组
 *
 * @static
 * @param {number} n
 * @returns
 *
 */
export const range = function (n) {
  return Array.from(new Array(n).keys());
};

/**
 * 删除对象的某个键
 *
 * @param {object} obj
 * @param {string} path 数据路径
 */
export const removeKey = function (obj, path) {
  const pathList = path.split(".");
  const length = pathList.length;
  if (length > 1) {
    const valueKey = pathList[length - 1];
    const targetKey = pathList.slice(0, length - 1).join(".");
    const target = get(obj, targetKey, {});
    delete target[valueKey];
  } else {
    delete obj[path];
  }
};

/**
 * 批量删除对象的键
 *
 * @param {object} obj
 * @param {array} pathList
 * @returns object
 */
export const removeKeys = function (obj, pathList) {
  const list = toArray(pathList);
  list.forEach((path) => {
    removeKey(obj, path);
  });
  return obj;
};

/**
 * 处理一些映射相关的特殊指令
 * @param {object} source 数据源
 * @param {string} path 数据路径
 * path中，如果包含了某些特定指令，将会具有一些特殊功能 , 只要第一个字符是@ 即进入指令判断流程   从@开始到下一个空格为止，即是指令
 * 1、@~ 如果指令是 '@~ ' 那该path将会直接作为val值，而不会作为path参与get
 * 2、@for 如果指令 是 '@for' 那意味着这个数据源如果是数组， 则循环这个数组并以路径为数组中的对象路径
 * 2、@fieldTypeMapping 如果指令 是 '@fieldTypeMapping' 元数据字段类型映射 那意味着这个数据源将会从config的metadataDict.fieldType取数据进行字段类型映射
 * 2、@ternaryOperator 如果指令 是 '@ternaryOperator' 三元表达式 规律  @ternaryOperator{==}条件?值1:值2   用取到的值进行三元表达式判断
 * 3、@fun 如果当前项的值是函数，则执行函数，并传递2个参数source,lodash（直接函数或者@fun模式都可以使用）
 * @returns object | string
 */
export const mappingInstruction = function (source, path) {
  let val = get(source, path, ""); //从数据源中得到的值
  if (path && path[0] == "@") {
    let instruciton = path.substring(0, path.indexOf(" ")); //指令
    let instrucitonPath = path.substring(path.indexOf(" ") + 1, path.length); //排除指令后的路径
    let fieldTypes = get(config, "metadataDict.fieldType", []); //字段类型映射表
    val = get(source, instrucitonPath, ""); //用去除指令后的路径去再次取数据
    //如果是排除指令，将会不参与映射，直接返回
    if (instruciton == "@~") {
      return instrucitonPath;
    }
    //如果是元数据字段类型映射指令，元数据映射表存储在config中
    if (instruciton == "@fieldTypeMapping") {
      fieldTypes.map((item) => {
        if (get(item, "server") == val) {
          val = get(item, "front", "String");
        }
      });
    }
    // 如果是函数映射  则直接执行函数
    if (instruciton == "@fun") {
      let fun = deepStringToFun(instrucitonPath);
      return fun(source, lodash);
    }
    //如果带三元表达式指令，三元表达式
    if (instruciton.indexOf("@ternaryOperator") == 0) {
      let operator = instruciton.substring(
        instruciton.indexOf("{") + 1,
        instruciton.indexOf("}")
      ); //运算符
      let condition = instruciton.substring(
        instruciton.indexOf("}") + 1,
        instruciton.indexOf("?")
      ); //三元表达式条件
      let valOne = instruciton.substring(
        instruciton.indexOf("?") + 1,
        instruciton.indexOf(":")
      ); //三元表达式值1
      let valTwo = instruciton.substring(
        instruciton.indexOf(":") + 1,
        instruciton.length
      ); //三元表达式值2
      val = `"${val}" ${operator} "${condition}" ? "${valOne}" : "${valTwo}"`;
      val = eval(val);
    }
  }
  return val;
};

/**
 * 加强版数据模型映射函数，用于处理元数据相关内容
 *
 * @static
 * @param {object} source 数据源
 * @param {Array} dataModel 数据模型
 * path中，如果包含了某些特定指令，将会具有一些特殊功能
 * 1、@~ 如果path的前2个字符是 '@~ ' 那该path将会直接作为val值，而不会作为path参与get
 * 2、@for 如果指令 是 '@for' 那意味着这个数据源如果是数组， 则循环这个数组并以路径为数组中的对象路径
 * @returns object
 *
 */
export const mappingStrengthen = function (source, dataModel) {
  const result = isArray(dataModel) ? [] : {};
  Object.entries(dataModel).forEach((entries) => {
    const [key, path] = entries;
    if (path || path === false) {
      if (typeof path === "string") {
        //处理一些特殊指令
        let val = mappingInstruction(source, path, key);
        result[key] = val;
      } else if (path instanceof Array) {
        let forResult = [];
        path.map((item) => {
          if (item) {
            let forPath = get(item, "@for"); //循环的对象的路径
            //如果存在for循环对象
            if (forPath) {
              let forData = get(source, forPath, []); //循环的对象，指向的应该是数据源中的某个数组
              forData.map((forItem) => {
                let forPushData = mappingStrengthen(forItem, item);
                delete forPushData["@for"];
                forResult.push(forPushData);
              });
            } else {
              let forPushData = mappingStrengthen(source, item);
              delete forPushData["@for"];
              forResult.push(forPushData);
            }
          }
        });
        result[key] = forResult;
      } else if (path === true || path === false) {
        result[key] = path;
      } else if (typeof path === "number") {
        result[key] = path;
      } else if (isFunction(path)) {
        result[key] = path(source, lodash);
      } else {
        result[key] = mappingStrengthen(source, path);
      }
    }
  });
  return result;
};

/**
 * 数据模型映射函数
 *
 * @static
 * @param {object} source 数据源
 * @param {Array} dataModel 数据模型
 * @returns object
 *
 */
export const mapping = function (source, dataModel) {
  const result = {};
  Object.entries(dataModel).forEach((entries) => {
    const [key, path] = entries;
    if (path) {
      if (typeof path === "string") {
        result[key] = get(source, path, "");
      } else if (path instanceof Array) {
        result[key] = path.map((p) => mapping(source, p));
      } else {
        result[key] = mapping(source, path);
      }
    }
  });
  return result;
};

/**
 * 包装工厂函数，数据映射超集，多一个处理函数
 *
 * @static
 * @param {object} source 数据源
 * @param {object} mod 数据模型
 * @param {Function} hander 处理函数
 * @param {Function} modMapping 自定义的模板映射函数
 * @returns
 *
 */
export const factory = function (source, mod, hander, modMapping) {
  let result = source;
  if (hander) {
    result = hander(source);
  } else if (mod) {
    const fun = modMapping || mapping;
    result = fun(source, mod);
  }
  return result;
};

/**
 * 局部变更key
 *
 * @param {object} sourceObj
 * @param {array<object>} mapList
 * @returns
 */
export const localChangeKey = function (sourceObj, mapList) {
  const list = toArray(mapList);
  list.map((dict) => {
    const { target, source, activeTarget } = dict;
    const value = get(sourceObj, source, "");
    let activeTargetValue = "";
    if (activeTarget) {
      activeTargetValue = get(sourceObj, activeTarget, "");
    }
    if (source) {
      if (typeof activeTargetValue === "string" && activeTarget) {
        lodashSet(sourceObj, activeTargetValue, value);
        if (target) {
          removeKey(sourceObj, target);
        }
      } else if (typeof target === "string") {
        lodashSet(sourceObj, target, value);
      }
      removeKey(sourceObj, source);
    }
  });
  return sourceObj;
};

/**
 * 局部将对象的键映射转换
 *
 * @param {object} source 数据源
 * @param {object} mod 数据模型
 * @param {Function} hander 处理函数
 */
export const localFactory = function (source, mapList, hander) {
  return factory(source, mapList, hander, localChangeKey);
};

/**
 * 生成随机数
 *
 * @param {number} [n=32]
 * @returns
 */
export const random = function (n = 32) {
  let chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
  let letter = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz";
  let maxPos = chars.length;
  let result = "";
  for (let i = 0; i < n; i++) {
    result += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  result = letter.charAt(Math.floor(Math.random() * letter.length)) + result;
  return result.substring(0, result.length - 1);
};
/**
 * description: 判断对象是否为空 Json {}
 * param :
 * return {*}
 * param {*} obj
 */
export const objIsEmpty = (obj) => {
  if (obj instanceof Object) {
    if (JSON.stringify(obj) && JSON.stringify(obj) === "{}") return true;
    return false;
  }
  return false;
};

/**
 * 转换成数组
 *
 * @param {*} source
 * @returns
 */
export const toArray = function (source) {
  if (source instanceof Array) {
    return source;
  } else {
    const result = source != null ? [source] : [];
    return result;
  }
};

/**
 * 字符串模板转换 ，将数据源对应{键}的值填入str
 *
 * @param {*} str 字符串
 * @param {*} source 数据源
 * @param {*} handle 处理函数
 * @returns
 */
export const strFormat = function (str, source, handle = () => {}) {
  if (str instanceof Function) {
    return str(source);
  } else if (!isObject(source)) {
    return str;
  }
  const data = { ...source };
  const r = /{[^}]+}/;
  while (r.test(str)) {
    const key = str.match(r).toString().replace("{", "").replace("}", "");
    const value = get(data, key, []);
    const ids = toArray(value).filter((id) => id != null);
    str = str.replace(r, ids.join(","));
    handle(key, value);
  }
  return str;
};

/**
 * 判断一个元素是否为空
 *
 * @param {*} source
 * @returns
 */
export const isEmpty = function (source) {
  const filterIdent = [undefined, null, "", [], "undefined", "null"];
  if (filterIdent.some((ident) => isEqual(ident, source))) {
    return true;
  }
  return false;
};

/**
 * 若列表项是一个函数，则调用函数并且判断是否为true，若true则返回true
 *  若列表项非函数，则判断想到
 * @param {*} list
 * @param {*} source
 */
const includesPro = function (list, source) {
  for (let val of toArray(list)) {
    if (val instanceof Function && val(source) === true) {
      return true;
    } else if (val === source) {
      return true;
    }
  }
  return false;
};

/**
 * 递归删掉一个对象中的所有节点
 * @param {*} obj
 * @returns
 */
export const filterDom = function (obj) {
  if (React.isValidElement(obj)) {
    return null;
  } else if (obj instanceof Array) {
    const result = obj.map((item) => filterDom(item)).filter((i) => i != null);
    return result;
  } else if (isObject(obj)) {
    let result = {};
    for (let key of Object.keys(obj)) {
      const item = obj[key];
      const newItem = filterDom(item);
      if (newItem != null) {
        result[key] = newItem;
      }
    }
    return result;
  } else {
    return obj;
  }
};

/**
 * 若emptyList为空则过滤对象中的无效值，否则过滤emptyList里的值
 *
 * @param {object} source
 * @param {Array} emptyList 自定义过滤项
 * @param {Function} config.handle
 * @param {string} config.mode 过滤模式，深度-deep,浅层不传 deep
 * @returns
 */
export const filterEmpty = function (source, config = {}, emptyList) {
  const result = {};
  const mergeConfig = merge({ mode: "", handle: () => {} }, config);
  const { mode, handle } = mergeConfig;
  for (let key of Object.keys(source)) {
    const value = source[key];
    const clearStatus =
      emptyList == null ? isEmpty(value) : includesPro(emptyList, value); // 指定可以过滤其他元素
    if (!clearStatus) {
      if (mode !== "deep") {
        result[key] = value;
      } else {
        if (value instanceof Array) {
          result[key] = value.map((item) => filterEmpty(item, mergeConfig));
        } else if (isObject(value)) {
          result[key] = filterEmpty(value, mergeConfig);
        } else {
          result[key] = value;
        }
      }
    } else if (handle(key, value) === true) {
      result[key] = value;
    }
  }
  return result;
};

/**
 * 数组转连接字符串，如果有一项是非值类型则返回原数组
 *
 * @param {array} array
 * @param {string} [joinMark=','] 连接符
 * @returns
 */
export const arrayJoin = function (array, joinMark = ",") {
  const result = [];
  for (let item of array) {
    if (["string", "number"].includes(typeof item)) {
      result.push(item);
    } else {
      return array;
    }
  }
  return result.join(joinMark);
};
/**
 * 深度将对象的数组转成字符串
 *
 * @param {object} source
 * @param {string} [jointMark=',']
 */
export const deepArrayToStr = function (source, jointMark = ",") {
  const result = {};
  for (let key of Object.keys(source)) {
    const value = source[key];
    if (value instanceof Array) {
      result[key] = arrayJoin(value, jointMark);
    } else if (isObject(value)) {
      result[key] = deepArrayToStr(value, jointMark);
    } else {
      result[key] = value;
    }
  }
  return result;
};

/**
 * 将对象转换成查询参数附加到url后面
 *
 * @param {*} path
 * @param {*} param
 * @returns
 */
export const getPath = function (path, param) {
  let result = "";
  if (path.includes("?")) {
    let route = path + `&${queryParam(param)}`;
    result = route.replace("??", "?").replace("&&", "&");
  } else {
    let route = path + `?${queryParam(param)}`;
    result = route.replace("??", "?");
  }
  return result;
};

/**
 * 两个新老对象中，对checkList键的值进行批量比较，返回一个新对象，存储不相等的键-值的对象
 *
 * @param {array} checkList 键集合
 * @param {object} obj1 旧对象
 * @param {object} nextObj 新对象
 * @param {Function} handle 处理函数
 * @returns
 */
export const filterObj = function (
  obj,
  nextObj,
  checkList = [],
  handle = null
) {
  let result = {};
  const checkArray = toArray(checkList);
  let keyList = checkArray.length === 0 ? Object.keys(obj) : checkArray;
  for (let key of keyList) {
    if (!isEqual(obj[key], nextObj[key])) {
      if (handle instanceof Function) {
        let value = handle(obj, nextObj, key) === false;
        if (value === false) {
          result[key] = value;
        } else {
          return result;
        }
      } else {
        const value = nextObj[key];
        result[key] = value;
      }
    }
  }
  return result;
};

/**
 * 判断一组值是否相等,有一组不等返回false
 *
 * @param {Array<Array>} [sources=[]] 二维数组
 */
export const isEqualBatch = function (sources = []) {
  for (let source of sources) {
    if (!isEqual(...source)) {
      return false;
    }
  }
  return true;
};

/**
 * 多个数组合并
 *
 * @param {*} arrays
 * @returns
 */
export const arrayConat = function (...arrays) {
  let result = [];
  for (let arr of arrays) {
    result = result.concat(toArray(arr));
  }
  return result;
};

/**
 *  dom 元素的 resize 监听对象
 *
 * @returns
 */
export const mutationObserver = function (element, attributeFilter, callback) {
  const keys = [
    "MutationObserver",
    "WebKitMutationObserver",
    "MozMutationObserver",
  ];
  const Observer = get(window, keys, null);
  const observer = new Observer(callback);
  observer.observe(element, {
    attributes: true,
    childList: true,
    characterData: true,
    subtree: true,
    attributeFilter: toArray(attributeFilter).concat("style") || undefined,
  });
  return observer;
};

/**
 * 向上寻找指定条件的父级
 *
 * @param {*} selector
 * @param {*} conditions
 * @returns
 */
export const findParentDom = function (selector, conditions) {
  const children = document.querySelector(selector);
  let keepDom = children;
  const [key, value] = conditions.split("=");
  for (let i = 0; i < 30; i++) {
    const father = get(keepDom, "parentElement", null);
    if (father == null) {
      break;
    } else if (isEqual(father[key], value)) {
      return father;
    } else {
      keepDom = get(keepDom, "parentElement", null);
    }
  }
  return null;
};

/**
 * 判断是否为ie浏览器
 *
 * @returns number| 'edge'
 */
export const ieVersion = function () {
  let version = -1;
  let userAgent = window.navigator.userAgent; //取得浏览器的userAgent字符串
  let isIE =
    userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
  let isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
  let isIE11 =
    userAgent.indexOf("Trident") > -1 && userAgent.indexOf("rv:11.0") > -1;
  if (isIE) {
    let reIE = new RegExp("MSIE (\\d+\\.\\d+);");
    reIE.test(userAgent);
    let fIEVersion = parseFloat(RegExp["$1"]);
    let ieVersionList = [7, 8, 9, 10];
    if (ieVersionList.includes(fIEVersion)) {
      version = fIEVersion + "";
    } else {
      version = "6";
    }
  } else if (isEdge) {
    return "edge"; //edge
  } else if (isIE11) {
    version = "11"; //IE11
  } else {
    version = "-1"; //不是ie浏览器
  }
  return version;
};

/**
 * 计算数组的和
 *
 * @param {*} list
 * @returns
 */
export const sum = function (list) {
  const array = toArray(list);
  return array.reduce((total, n) => {
    if (typeof n === "string") {
      return total + parseFloat(n);
    }
    return total + n;
  }, 0);
};

/**
 * 计算属性值
 *
 * @param {*} ele
 * @param {*} key
 * @returns
 */
export const computedStyle = function (ele, key) {
  const version = ieVersion();
  if (["-1", "edge"].includes(version)) {
    return window.getComputedStyle(ele).getPropertyValue(key);
  }
  return ele.currentStyle[key];
};

/**
 * 抵消属性导致的滚动条消失
 *
 * @param {HTMLElement} dom dom元素
 * @param {object} scroll
 * @returns object
 */
const offsetScroll = function (dom, scroll) {
  const overflow = computedStyle(dom, "overflow");
  const overflowX = computedStyle(dom, "overflow-x");
  const overflowY = computedStyle(dom, "overflow-y");
  const dict = {
    "width-height": overflow,
    width: overflowX,
    height: overflowY,
  };
  Object.keys(dict).forEach((key) => {
    const value = dict[key];
    const keys = key.split("-");
    if (value === "hidden") {
      keys.forEach((k) => (scroll[k] = 0));
    }
  });
  return scroll;
};

/**
 * 计算元素产生的滚动条长度
 *
 * @param {*} selector
 */
export const scrollBar = function (selector) {
  const dom = document.querySelector(selector);
  const [clientWidth, clientHeight] = getBatch(
    dom,
    ["clientWidth", "clientHeight"],
    0
  );
  const scrollWidth = get(dom, "scrollWidth", 0);
  const scrollHeight = get(dom, "scrollHeight", 0);
  let dxWidth = scrollWidth - clientWidth;
  let dxHeight = scrollHeight - clientHeight;
  if (dom != null) {
    let result = { width: Math.max(0, dxWidth), height: Math.max(0, dxHeight) };
    result = offsetScroll(dom, result);
    return result;
  }
  return { width: 0, height: 0 };
};

/**
 * 不会报错的json parse
 *
 * @param {*} obj
 * @returns
 */
export const jsonpParse = function (obj) {
  try {
    return JSON.parse(obj);
  } catch (error) {
    return obj;
  }
};

/**
 * 替换所有目标目标字符串
 *
 * @param {*} str
 * @param {*} searchValue
 * @param {*} symbol
 * @returns
 */
export const replaceAll = function (str, searchValue, symbol) {
  let result = str;
  while (result.includes(searchValue)) {
    result = result.replace(searchValue, symbol);
  }
  return result;
};

/**
 * 在树中找到匹配当前id的层级
 *
 * @param {*} tree
 * @param {*} id
 * @returns
 */
export const findNodeTree = function (tree, id) {
  for (let node of tree) {
    const key = String(get(node, "key", ""));
    const children = get(node, "children", null);
    if (key === id) {
      return node;
    } else if (children) {
      const target = findNodeTree(children, id);
      if (target != null) {
        return target;
      }
    }
  }
  return null;
};

/**
 * 根据id找到父级
 *
 * @param {Array} tree
 * @param {String} id
 */
export const findNodeParent = function (tree, id) {
  for (let node of tree) {
    const children = get(node, "children", []);
    const target = children.find((n) => n.key === id);
    if (target != null) {
      return node;
    } else if (children != null) {
      const target_ = findNodeParent(children, id);
      if (target_ != null) {
        return target_;
      }
    }
  }
  return null;
};

/**
 * 判断是否是叶子节点
 *
 * @param {*} tree
 * @param {*} id
 */
export const treeLeaves = function (tree, id) {
  let obj = findNodeTree(tree, id);
  if (obj == null) {
    return false;
  } else if (obj.children != null) {
    return false;
  }
  return true;
};

/**
 * 对象转表单数据
 *
 * @param {*} obj
 * @returns
 */
export const objToFormData = function (obj) {
  const source = obj || {};
  const formData = new FormData();
  for (let [name, val] of Object.entries(source)) {
    formData.append(name, val);
  }
  return formData;
};

export const downFile = downFileAction;

/**
 * 深拷贝改良版，遇到节点将不递归拷贝
 *
 * @param {*} source
 * @param {Array} condictions 条件函数集 (item,key) 返回false时不拷贝
 */
export const cloneDeep = function (source, condictions) {
  const cs = [...(condictions instanceof Array ? condictions : [])];
  return cloneDeepWith(source, (item, key) => {
    const list = [
      React.isValidElement(item),
      get(item, "validateFieldsAndScroll", null) instanceof Function,
      ...cs,
    ];
    for (let c of list) {
      if (c instanceof Function && c(item, key) === false) {
        return item;
      } else if (c === true) {
        return item;
      }
    }
  });
};

/**
 * 渲染节点加工函数，仅仅渲染非数组节点
 *
 * @param {*} node
 * @param {*} data
 * @param {*} extraParam 额外的参数
 */
export const nodeProcess = function (node, data, extraParam) {
  if (React.isValidElement(node) || typeof node === "string") {
    return node;
  } else if (node instanceof Function) {
    return node(data, extraParam);
  }
  return node;
};

/**
 * 渲染节点函数
 *
 * @param {Array} node 节点
 * @param {*} data 数据源
 * @param {*} extraParam 额外的参数
 */
export const nodeFactory = function (nodeList, data, extraParam) {
  if (nodeList instanceof Array) {
    return nodeList.map((node) => nodeProcess(node, data, extraParam));
  } else {
    return nodeProcess(nodeList, data, extraParam);
  }
};

/**
 * 遍历一个对象，遇到函数即执行函数，并附加参数为函数形参
 *
 * @param {Array} obj 要遍历的对象
 * @param {*} param 要附加的参数
 */
export const objectFactory = function (obj, param) {
  if (isObject(obj)) {
    for (let i in obj) {
      if (isFunction(obj[i])) {
        let click = obj[i];
        obj[i] = () => {
          click(param);
        };
      }
    }
  }
  return obj;
};

/**
 * 收紧相邻的元素
 *
 * @param {Array} data
 * @param {String|null} key
 * @returns
 */
export const frap = function (source, key) {
  const data = toArray(source);
  const result = [];
  let i = 0;
  while (i < data.length - 1) {
    const item = data[i];
    let middle = [item];
    i += 1;
    let next = data[i];
    while (next[key] === item[key] || next === item) {
      middle.push(next);
      i += 1;
      next = data[i];
    }
    result.push(middle);
  }
  return result;
};

export const exitFullscreen = function () {
  const list = [
    "exitFullscreen",
    "msExitFullscreen",
    "mozCancelFullScreen",
    "webkitExitFullscreen",
  ];
  for (let funKey of list) {
    if (document[funKey] instanceof Function) {
      document[funKey]();
      return;
    }
  }
};

export const launchFullscreen = function (element) {
  const fullScreenList = [
    "requestFullscreen",
    "mozRequestFullScreen",
    "msRequestFullscreen",
    "webkitRequestFullScreen",
  ];
  const action = get(element, fullScreenList, () => {});
  action.call(element);
};

/**
 * 文本域回车切割为数组
 *
 * @param {*} [data={}]
 * @param {*} [fields=[]]
 * @returns
 */
export const textAreaBatch = function (data = {}, fields = []) {
  const thatData = typeof data === "string" ? jsonpParse(data) : data;
  let changeParam = {};
  for (let field of toArray(fields)) {
    let value = get(thatData, field, null);
    if (value == null) {
      continue;
    } else {
      value = value
        .split("\n")
        .filter((row) => !["", "\n"].includes(row))
        .join(",");
      changeParam[field] = value;
    }
  }
  const result = { ...thatData, ...changeParam };
  return typeof data === "string" ? JSON.stringify(result) : result;
};

/**
 * 递归取得选中的节点
 *
 * @param {*} treeList
 */
export const treeChecked = function (treeList) {
  let result = [];
  for (let treeNode of toArray(treeList)) {
    const children = get(treeNode, "children", null);
    const key = get(treeNode, "key", "");
    const selected = get(treeNode, "selected", false);
    if (children == null && selected === true) {
      result.push(key);
    } else {
      result = result.push(...treeChecked(children));
    }
  }
  return result;
};

/**
 * 判断字段变化，执行对应的函数
 *
 * @param {Object} propsDict
 * @param {Object} [fields={}]
 */
export const receiveProps = function (propsDict, fields = {}) {
  const { props, nextProps } = propsDict;
  for (let key of Object.keys(fields)) {
    const callback = fields[key];
    if (!isEqual(props[key], nextProps[key])) {
      callback();
    }
  }
};

/**
 * 动态加载js
 *
 * @param {Object} srcDict src的字典
 */
export const createScriptFormRemote = function (srcDict) {
  for (let key of Object.keys(srcDict)) {
    if (document.querySelector(`#${key}`) == null) {
      const src = srcDict[key];
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = src;
      script.id = key;
      document.head.appendChild(script);
    }
  }
};

/**
 * 递归对象，遇到函数时，执行它并且填充回当前key
 *
 * @param {object} source
 */
export const deepHandle = function (source, data) {
  let result = {};
  const list = [
    source == null,
    source instanceof RegExp,
    React.isValidElement(source),
    ["string", "number"].includes(source),
  ];
  if (list.some((l) => l)) {
    result = source;
  } else if (source instanceof Function) {
    result = source(data);
  } else if (source instanceof Array) {
    result = source.map((val) => deepHandle(val));
  } else if (isObject(source)) {
    for (let key of Object.keys(source)) {
      result[key] = deepHandle(source, data);
    }
  } else {
    result = source;
  }
  return result;
};

/**
 * 获得函数的参数数组
 *
 * @param {*} fn
 * @returns
 */
export const annotate = function (fn) {
  var FN_ARGS = /^function\s*[^\(]*\(\s*([^\)]*)\)/m;
  var FN_ARG_SPLIT = /,/;
  var FN_ARG = /^\s*(_?)(.+?)\1\s*$/;
  var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/gm;
  var $inject, fnText, argDecl, last;
  if (typeof fn == "function") {
    if (!($inject = fn.$inject)) {
      $inject = [];
      fnText = fn.toString().replace(STRIP_COMMENTS, "");
      argDecl = fnText.match(FN_ARGS);
      Array.forEach(argDecl[1].split(FN_ARG_SPLIT), function (arg) {
        arg.replace(FN_ARG, function (all, underscore, name) {
          $inject.push(name);
        });
      });
      fn.$inject = $inject;
    }
  } else if (isArray(fn)) {
    last = fn.length - 1;
    assertArgFn(fn[last], "fn");
    $inject = fn.slice(0, last);
  } else {
    assertArgFn(fn, "fn", true);
  }
  return $inject;
};

/**
 * 深度将函数转成字符串
 *
 * @param {*} obj
 * @returns
 */
export const deepFunToString = function (obj) {
  if (obj instanceof Function) {
    const code = obj.toString();
    const args = annotate(obj);
    const body = code.slice(code.indexOf("{") + 1, code.lastIndexOf("}"));
    return `${args.join(",")}|yx-function|${body}`;
  } else if (obj instanceof Array) {
    let result = obj.map((item) => deepFunToString(item));
    return result;
  } else if (React.isValidElement(obj)) {
    let body = get(obj, "props.dangerouslySetInnerHTML.__html", "");
    return `|yx-htmlNode|${body}`;
  } else if (isObject(obj)) {
    let result = {};
    for (let key of Object.keys(obj)) {
      const item = obj[key];
      result[key] = deepFunToString(item);
    }
    return result;
  } else {
    return obj;
  }
};

/**
 * 将前缀为$window的字符串挂载上真正的函数
 *
 * @param {String} str
 */
export const mountString = function (str) {
  const ident = "$window.";
  const prefix = str.slice(0, ident.length);
  if (prefix === ident) {
    const functionName = str.replace(ident, "");
    return get(window, functionName, () => {
      console.error("函数未定义");
    });
  }
  return str;
};

const deepStringToFunNode = function (obj) {
  let idText = "|yx-function|";
  let idNode = "|yx-htmlNode|";
  if (obj.includes(idText)) {
    return { ident: idText, type: 1 };
  } else if (obj.includes(idNode)) {
    return { ident: idNode, type: 2 };
  }
  return false;
};

/**
 * 将 deepFunToString 函数处理过的数据，转换回正常的数据
 *
 * @param {*} obj
 * @returns
 */
export const deepStringToFun = function (obj) {
  const extra = { React, ReactDom, lodash, Moment };
  if (isString(obj)) {
    let result = deepStringToFunNode(obj);
    if (result) {
      let { type, ident } = result;
      const [args, code] = obj.split(ident);
      if (type === 2) {
        return <span dangerouslySetInnerHTML={{ __html: code }}></span>;
      }
      const f = new Function(...args.split(","), code);
      return (...args) => f(...args, extra);
    }
    return mountString(obj);
  } else if (obj instanceof Array) {
    let result = obj.map((item) => deepStringToFun(item));
    return result;
  } else if (obj instanceof Function) {
    return (...args) => obj(...args, extra);
  } else if (isObject(obj)) {
    let result = {};
    for (let key of Object.keys(obj)) {
      const item = obj[key];
      result[key] = deepStringToFun(item);
    }
    return result;
  } else {
    return obj;
  }
};

/**
 * 使用原生的ajax请求get数据
 * @param {string} param.url 请求地址
 * @returns
 */
export const ajaxGet = function (param) {
  let url = get(param, "url", "");
  if (!url) {
    console.error("请求url不能为空", param);
    return false;
  }
  let jqrequest = new GetXhr(url);
  return jqrequest.send();
};

/**
 * 去除字符串头尾字符串
 *
 * @param {*} str
 * @param {string} [searchValue='/']
 * @returns
 */
export const trimStr = function (str, searchValue = "/") {
  const r = new RegExp(`(^${searchValue}*)|(${searchValue}*$)`, "g");
  return str.replace(r, "");
};

/**
 * 字符串加工
 *
 * @param {*} obj
 * @param {*} data
 */
export const objectF = function (obj, data) {
  if (obj instanceof Function) {
    return obj(data);
  }
  return obj;
};

export const sleep = function (time) {
  return new Promise((resolve) => {
    setTimeout(resolve, time);
  });
};
export const closeFunction = function (func) {
  return new Function("return " + cloneDeep(func.toString()))();
};
/**
 * description: 获取浏览器内核类型
 * param  {*}
 * return {*} browser name 返回浏览器名称
 */
export const getBrowserName = function () {
  const u = navigator && navigator.userAgent;
  const browser = {
    trident: u.indexOf("Trident") > -1, //IE内核
    presto: u.indexOf("Presto") > -1, //opera内核
    webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
    gecko: u.indexOf("Firefox") > -1, //火狐内核Gecko
    mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios
    android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, //android
    iPhone: u.indexOf("iPhone") > -1, //iPhone
    iPad: u.indexOf("iPad") > -1, //iPad
    webApp: u.indexOf("Safari") > -1, //Safari
  };
  if (browser.trident) {
    return "ie"; //IE内核
  }
  if (browser.presto) {
    return "opera"; //opera内核
  }
  if (browser.webKit) {
    return "appleWebKit"; //苹果、谷歌内核
  }
  if (browser.gecko) {
    return "firefox"; //火狐内核Gecko
  }
  if (
    browser.versions.mobile ||
    browser.versions.ios ||
    browser.versions.android ||
    browser.versions.iPhone ||
    browser.versions.iPad
  ) {
    return "mobile"; //移动端
  }
};

/**
 * description: 解析参数中指令
 * 格式 #指令标记+|+指令类型+|+指令参数# 指令标记:#yx-command# 指令类型:&data&（数据源）指令参数
 * 如：http://baidu.com?a=#yxCommand|data|data.key.value#&b=#yxCommand|data|data.key.valuek#  在数据源中取路径为data.key.value 的值
 * @param {string} commandParam.data 需要执行数据源
 * @param {obj} commandParam.command 包含指令参数
 * @param {obj} commandParam._this 包含指令参数
 * @param {param} commandParam.componentParam 包含指令参数
 * return {*}
 */
export const command = (commandParam) => {
  const { command, data, _this, componentParam } = commandParam;
  const reg = /\#yxCommand\|(.*?)\|(.*?)\#/g;
  const commandArray = isString(command) && command.match(reg);
  if (isArray(commandArray)) {
    let commandReplace = command;
    // 解析指令
    let commandValue = commandArray.map((item, index) => {
      const value = commandType(item, data, _this, componentParam);
      return { key: item, value };
    });
    // commandValue = await Promise.all(commandValue);
    if (get(commandValue, "length", 0) > 0) {
      // 替换指令，多条指令前提下，当只有一个request 直接返回
      commandValue.forEach((item, index) => {
        if (isFunction(item.value)) {
          commandReplace = item.value;
        } else {
          // 当返回值为对象时全部替换，如果是只付出支持部分替换
          commandReplace = isString(item.value)
            ? commandReplace.replace(item.key, item.value)
            : (commandReplace = item.value);
        }
      });
    }
    return commandReplace;
  }
  return command;
};
/**
 * description: 判断指令类型执行指令
 * @param {string} command 单个指令字符串
 * @param {obj} componentData 数据源
 * @param {obj} _this 组件调用组件this
 * @param {obj} param 组件配置参数
 *
 */
const commandType = (command, componentData = {}, _this, param) => {
  const commandArray = command.replace(/(^#)|(#$)/g, "").split("|");
  switch (commandArray[1]) {
    case "data":
      const getParam = commandArray[2].split("@");
      return get(componentData, getParam[0], getParam[1]);
    case "request":
      const requestParam = commandArray[2].split(",");
      const data = getRequest({
        url: requestParam[0],
        method: requestParam[1],
      });
      return data.data;
    case "url":
      return getQueryString(commandArray[2]);
    case "setData":
      // {code:'',value:{version: Math.random()},dataIndex:2} code:组件唯一标记，value 传入值，dataIndex 回调方法值下标
      try {
        const paramJson = JSON.parse(commandArray[2]);
        const fc = (...reg) => {
          const { componentStore } = _this.state;
          let json = { ...paramJson.value };
          if (reg[paramJson.dataIndex]) {
            json = merge(json, reg[paramJson.dataIndex]);
          }
          _this.setState({
            componentStore: merge(componentStore, {
              [paramJson.code]: { ...json },
            }),
          });
        };
        return fc;
      } catch (error) {
        return error;
      }
    default:
      break;
  }
};
/**
 * description: 解析不同结构参数指令
 * @param {*} param 需要解析参数
 * @param {*} data 数据源，目前data 指令中会使用
 * @param {obj} _this 组件调用组件this
 * @param {obj} componentParam 组件配置参数
 * return {*} 返回解析后参数
 */
export const paramFactory = (param, data, _this, componentParam) => {
  // 字符串直接处理返回
  if (isString(param))
    return command({ command: param, data, _this, componentParam });
  if (
    React.isValidElement(param) ||
    isFunction(param) ||
    param._isAMomentObject //momentl类型校验
  ) {
    return param;
  }
  let str = (isArray(param) && []) || (isObject(param) && {});
  for (let i in param) {
    if (isArray(param[i]) || isObject(param[i]) || isString(param[i])) {
      str[i] = paramFactory(param[i], data, _this, componentParam);
    } else {
      // 数字或者null 等特殊内容直接返回
      str[i] = param[i];
    }
    // str[i] = command({ command: param[i], data });
  }
  return str;
};
export default {
  getBrowserName,
  closeFunction,
  sum,
  get,
  frap,
  range,
  merge,
  random,
  getPath,
  mapping,
  mappingStrengthen,
  toArray,
  message,
  factory,
  batchGet,
  downFile,
  timeZone,
  removeKey,
  strFormat,
  cutOffUrl,
  filterObj,
  arrayJoin,
  scrollBar,
  ieVersion,
  deepHandle,
  arrayConat,
  treeLeaves,
  queryParam,
  replaceAll,
  jsonpParse,
  removeKeys,
  queryToObj,
  filterEmpty,
  receiveProps,
  findNodeTree,
  numberFormat,
  localFactory,
  textAreaBatch,
  objToFormData,
  findParentDom,
  exitFullscreen,
  getQueryString,
  localChangeKey,
  deepArrayToStr,
  launchFullscreen,
  mutationObserver,
  createScriptFormRemote,
  ajaxGet,
  objectFactory,
  objIsEmpty,
  command,
  paramFactory,
};



// WEBPACK FOOTER //
// ./src/yx-widget/utils/index.js